import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import 'dayjs/locale/ro';
import './global.css';

import { QueryClientProvider } from '@tanstack/react-query';
import { App as AntdApp, ConfigProvider } from 'antd';
import roRO from 'antd/locale/ro_RO';
import dayjs from 'dayjs';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { queryClient } from './api/queryClient';
import { App } from './App';
import { theme } from './theme';

dayjs.locale('ro');

const container = document.getElementById('root');
if (!container) {
  throw new Error('Elementul #root lipsește din index.html.');
}

createRoot(container).render(
  <StrictMode>
    <ConfigProvider locale={roRO} theme={theme}>
      <AntdApp>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </AntdApp>
    </ConfigProvider>
  </StrictMode>,
);
